import config from '../../config/config.js';

const serverUrl = config.serverUrl;
const BASE_URL = serverUrl; //"http://localhost:8006"

const analyticsConfig = [
    {
        tabName: "Driver Earnings", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/driver_earnings`, // API endpoint
        searchKey: "driver_id",
        columns: [
            { id: "driver_id", label: "Driver ID" },
            { id: "driver_name", label: "Driver Name" },
            { id: "phone_number", label: "Driver Phone No." },
            { id: "total_rides", label: "Total Rides" },
            { id: "total_earnings", label: "Total Earnings" },
        ],
        params: {
            client_id: true,
            start_date: true,
            end_date: true,
        },
    },
    {
        tabName: "User Wallet Report", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/wallet_transaction_report`, // API endpoint
        searchKey: "user_id",
        showTxnTypeFilter: true,
        columns: [
            { id: "user_id", label: "User ID" },
            { id: "txn_type", label: "Transaction Type" },
            { id: "txn_event", label: "Transaction Event" },
            { id: "amount", label: "Amount" },
            { id: "reason", label: "Reason" },
            { id: "logged_on", label: "Logged On" },
        ],
        params: {
            user_id: false,
            user_type: 0, // 0 stands for customer
            start_date: true,
            end_date: true,
        },
    },
    {
        tabName: "Driver Wallet Report", // Tab name
        apiEndpoint: `${BASE_URL}/analytics/wallet_transaction_report`, // API endpoint
        searchKey: "user_id",
        showTxnTypeFilter: true,
        columns: [
            { id: "user_id", label: "Driver ID" },
            { id: "txn_type", label: "Transaction Type" },
            { id: "txn_event", label: "Transaction Event" },
            { id: "amount", label: "Amount" },
            { id: "reason", label: "Reason" },
            { id: "logged_on", label: "Logged On" },
        ],
        params: {
            user_id: false,
            user_type: 1, // 1 stands for driver
            start_date: true,
            end_date: true,
        },
    },
];

export default analyticsConfig;